import { render, staticRenderFns } from "./TodasMenssagensChat.vue?vue&type=template&id=53c168ba&scoped=true"
import script from "./TodasMenssagensChat.vue?vue&type=script&lang=js"
export * from "./TodasMenssagensChat.vue?vue&type=script&lang=js"
import style0 from "./TodasMenssagensChat.vue?vue&type=style&index=0&id=53c168ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c168ba",
  null
  
)

export default component.exports